module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Korrekciós kérelem")]), _vm._v(" "), _c('HallgatoAdatok', {
    on: {
      "onReady": function (hallgato, hallgato_szakok) {
        this$1.save_enabled = true;
        this$1.hallgato = hallgato;
        this$1.hallgato_szakok = hallgato_szakok
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n            Korrekció tárgya\n          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.Targy),
      expression: "form.Targy"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "kerelem_targya",
      "id": "kerelem_targya"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.Targy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.targyak), function(targy, i) {
    return _c('option', {
      domProps: {
        "value": targy.value
      }
    }, [_vm._v(_vm._s(targy.text))])
  })), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'Targy') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2), _vm._v(" "), _c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "cstyle": "min-height: 100px",
      "maxlength": "2000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "Indoklas",
      "label": "Indoklás",
      "name": "Indoklas"
    },
    model: {
      value: (_vm.form.Indoklas),
      callback: function($$v) {
        _vm.form.Indoklas = $$v
      },
      expression: "form.Indoklas"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Beküld")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Korrekciós kérelem")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }, [_vm._v(_vm._s(_vm.fill_info))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "panels"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Kérelem adatok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b312c534"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/korrekcios_kerelem.vue
// module id = 399
// module chunks = 0